/**
 * StoreCodeChangeRegistrations
 *
 * Registers all module store-reset handlers with module-quote's
 * storeChangeResetRegistry. Must be rendered inside CartProvider
 * so the registry is available before any store code change event.
 */

'use client';

import { useCheckoutStoreCodeChangeRegistration } from '@kidslabs/module-checkout';
import { useFlashSaleStoreCodeChangeRegistration } from '@kidslabs/module-flash-sale';

export const StoreCodeChangeRegistrations = (): null => {
    useCheckoutStoreCodeChangeRegistration();
    useFlashSaleStoreCodeChangeRegistration();
    return null;
};

